import qs from 'qs';

const Report = {
    namespaced: true,

    state: {
        reportData: [],
        apiKeyData: [],
    },

    
    

    getters: {
        reportData (state) {
            return state.reportData;
        },
        apiKeyData (state) {
            return state.apiKeyData;
        },
        
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['reportData'] = items;
        },

        setArrApiKey (state, { items }) {
            state['apiKeyData'] = items;
        },
         
        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['reportData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['reportData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['reportData'] = state['reportData'].filter(iItem => iItem !== item);
        },
    },


    actions: { 
        /**
         * Получить список отчетов 
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */

        getReportData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
               

                axios({
                    url: rootGetters.rootUrl + 'list/index', // save т.к. нужен POST запрос для передачи данных в сервис
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.reportList,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по отчетам получены'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по отчетам!'),
                    console.report('ERROR IN store.js | removeRoleData : ' + err);
                    reject(err);
                });
            })
        }, 

        /**
         * Получить текущий ключ сотрудника для формрования отчета
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */

        getApiKeyData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                const str = JSON.stringify({username: data.staffUsername}); 

                axios({
                    url: rootGetters.rootUrl + 'list/save', // save т.к. нужен POST запрос для передачи данных в сервис
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.reports,
                    }),
                }).then(response => (
                    commit('setArrApiKey', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по ответственному получены '),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных по ответственному!'),
                    console.report('ERROR IN store.js | removeRoleData : ' + err);
                    reject(err);
                });
            })
        }, 
    },
};

export default Report;





// WEBPACK FOOTER //
// ./src/store/modules/report.js